import React from 'react';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { Wrapper, Text, ButtonContainer, Button } from './styled';

class Banner extends React.Component {

    componentDidMount() {
        dataLayerPush({
            event: 'promoView',
            ecommerce: {
                promoView: {
                    promotions: [
                        {
                            id: 'tv_channel_movix_pro',
                            name: 'banner-movix-tv-channel',
                            creative: '1',
                            position: 'tv_channel_page'
                        }
                    ]
                }
            }
        });
    }

    handleClick = () => {
        dataLayerPush({
            event: 'promoClick',
            ecommerce: {
                promoView: {
                    promotions: [
                        {
                            id: 'tv_channel_movix_pro',
                            name: 'banner-movix-tv-channel',
                            creative: '1',
                            position: 'tv_channel_page'
                        }
                    ]
                }
            }
        });
        location.href = this.props.bannerInfo.link;
    }

    render() {
        const { bannerInfo = {} } = this.props;
        return (
            <Wrapper srcPath={process.env.CONTENT_API_ENDPOINT + bannerInfo.image}>
                <Text>{bannerInfo.title_ad}</Text>
                <ButtonContainer>
                    <Button
                        type='primary'
                        text={bannerInfo.button_text}
                        href={bannerInfo.link}
                        onClick={() => this.handleClick()}
                        data-test='btn'
                    />
                </ButtonContainer>
            </Wrapper>
        );
    }
}

export default Banner;
